'use client'
import { useEffect, useState } from 'react'
import posthog from 'posthog-js'
import { Cta } from '../../ui';
import Skeleton from '@mui/material/Skeleton'

const FEATURE_FLAG_KEY = 'jayco-build-and-price-dealer-btn'
const FALLBACK_COPY = 'Send your build to your local dealer'

// Reads the experiment variant + CTA copy and tracks form submissions against it
export function useBuildPriceDealerFlag (formSubmitted) {
  const [variant, setVariant] = useState(null);
  const [payloadCopy, setPayloadCopy] = useState(null);

  useEffect(() => {
    if (formSubmitted) {

      posthog.capture('form_submitted', {
      // optional: any useful properties
      button_location: 'build_price_dealer',
      feature_flag: FEATURE_FLAG_KEY,
      variant,
      })
    }
  }, [formSubmitted])

  const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN || 'phc_q5Dc8NfMjHRLQGQqvuzB9uxV75VSwukLncnxBvfebs5Y'

  useEffect(() => {

    const shouldReset = new URLSearchParams(window.location.search).get('posthog_reset') === 'true';

    posthog.init(token, {
      api_host:
        process.env.NEXT_PUBLIC_POSTHOG_HOST ||
        'https://us.i.posthog.com',

      autocapture: false,
      capture_pageview: false,
      debug: true,
      defaults: '2026-01-30',
      loaded: (ph) => {
        // reset() needs persistence set up by init(), so it must run in the loaded callback rather than before init()
        if (shouldReset) {
          console.info('post hog reset');
          ph.reset();
        }
      },
    })


    const readFlag = () => {
      const result = posthog.getFeatureFlagResult(FEATURE_FLAG_KEY)
      setVariant(result?.variant)
      // Set the CTA text per-variant in the PostHog dashboard as a JSON payload, e.g. { "text": "Book a viewing" }
      const payload = result?.payload

      const copy = payload && typeof payload.text === 'string' ? payload.text : FALLBACK_COPY
      // Sentence case: capitalise only the first letter, e.g. "Book Your viewing now" -> "Book your viewing now"
      setPayloadCopy(copy.charAt(0).toUpperCase() + copy.slice(1).toLowerCase())
    }

    // If flags are already loaded, read immediately; otherwise wait for them
    if (posthog.isFeatureEnabled(FEATURE_FLAG_KEY, { send_event: false }) !== undefined) {
      readFlag()
    } else {
      posthog.onFeatureFlags(readFlag)
    }
  }, [])

  const trackClick = () => {
    console.log('variant:', variant)

    posthog.capture('cta_clicked', {
      button_location: 'build_price_dealer',
      feature_flag: FEATURE_FLAG_KEY,
      variant,
    })
  }

  return { variant, payloadCopy, trackClick }
}

export default function BuildPriceDealerCta (props) {
  const { payloadCopy, trackClick } = useBuildPriceDealerFlag(props.formSubmitted)

  const handleClick = (e) => {
    trackClick()

    if (props.onClick) {
      props.onClick(e);
    }
  }

  return (
    <Cta type="button" onClick={handleClick}>
      {payloadCopy === null
        ? <Skeleton variant="text" sx={{ minWidth: '200px'}} />
        : payloadCopy}
    </Cta>
  )
}
